/**
 * User-level Google Calendar connection status.
 * When true, match events sync automatically on Schedule load.
 */

import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Check if user has connected their Google Calendar.
 */
export async function getCalendarConnected(userId) {
  if (!userId) return false;
  const ref = doc(db, 'userCalendarSettings', userId);
  const snap = await getDoc(ref);
  if (!snap.exists()) return false;
  return snap.data().calendarConnected === true;
}

/**
 * Set calendar as connected (after successful OAuth).
 */
export async function setCalendarConnected(userId, connected = true) {
  if (!userId) return;
  const ref = doc(db, 'userCalendarSettings', userId);
  await setDoc(ref, {
    calendarConnected: connected,
    updatedAt: new Date(),
  }, { merge: true });
}
